// Models
import Model from './Model'

class Transaction extends Model {
  get isIncoming () {
    return this.direction === TRANSACTION_DIRECTIONS.INCOMING
  }

  get isOutgoing () {
    return this.direction === TRANSACTION_DIRECTIONS.OUTGOING
  }

  get schema () {
    return [
      'accountId',
      'amount',
      'amountEuro',
      'createdAt',
      'currency',
      'currencyRates',
      'direction',
      'id',
      'partnerAccountId',
      'paymentOperationId'
    ]
  }
}

export const TRANSACTION_DIRECTIONS = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING'
}

export default Transaction
